import { SetLocalData } from './localStorage';
import _ from 'lodash';

export const SyncLocalRemote = async (key, localData, remoteData) => {
	if (!_.isEqual(localData, remoteData)) {
		SetLocalData(key, remoteData);
		return remoteData;
	}
	return localData;
};